<div class="container-fluid clearfix p-3"
  [ngStyle]="{'background-color': content.bgcolor, 'border-radius': content.borderRadius || '0', 'box-shadow': content.borderRadius ? '0px 0px 0px 1px rgba(207, 207, 207, 0.5), 0px 0px 5px 2px rgba(207, 207, 207, 0.2)' : 'none' }">
  <span class="label-txt" title="{{ content.title }}">{{ content.title }}</span>
  <span class="value-txt" [ngStyle]="{'color': content.valueColor || '#212529' }">{{ count }}</span>
</div>
